import React from 'react';
import { dark, primary, white } from 'react-components/dist/values/colors/colors';

const Logo = ({ light }) => {
  let color = light ? white : dark;
  return (
    <svg
version="1.1"
xmlns="http://www.w3.org/2000/svg"
x="0px"
y="0px"
viewBox="0 0 673.7 425.7">
      <g>
        <g>
          <path
            style={{ fill: color }}
            d="M0,391.3V289.7h39.8c29.2,0,45.9,22.1,45.9,51c0,28.8-16.7,50.6-45.9,50.6H0z M21.5,371.7h18.3
    			c16.2,0,24.3-14.3,24.3-31c0-16.8-8.1-31.4-24.3-31.4H21.5V371.7z"
          />
          <path
            style={{ fill: color }}
            d="M163.1,378.8c-6.9,10.3-19.8,14-31.4,14c-19.8,0-36-14.5-36-36.1c0-21.7,16.2-35.7,36-35.7
    			c19.6,0,35.3,14.6,35.3,36.3c0,1.8-0.1,4.6-0.3,6.3h-50.4c1,8,9.7,11.5,17,11.5c5.6,0,11.7-2.1,15-6.5L163.1,378.8z M146.3,350.8
    			c-1-8.4-8.7-11.8-14.5-11.8c-5.8,0-13.6,3.1-15.3,11.8H146.3z"
          />
          <path
            style={{ fill: color }}
            d="M242.2,378.8c-6.9,10.3-19.8,14-31.4,14c-19.8,0-36-14.5-36-36.1c0-21.7,16.2-35.7,36-35.7
    			c19.6,0,35.3,14.6,35.3,36.3c0,1.8-0.1,4.6-0.3,6.3h-50.4c1,8,9.7,11.5,17,11.5c5.6,0,11.7-2.1,15-6.5L242.2,378.8z M225.4,350.8
    			c-1-8.4-8.7-11.8-14.5-11.8c-5.8,0-13.6,3.1-15.3,11.8H225.4z"
          />
          <path
            style={{ fill: color }}
            d="M278.3,322.5v8.6c3.4-6.3,11.7-10,20.2-10c17.7,0,33.3,14,33.3,35.7c0,22.1-15.6,36.1-33.3,36.1
    			c-8.6,0-16.8-3.5-20.2-9.9v42.2h-20.4V322.5H278.3z M294.7,373.5c8.7,0,15.9-6.5,15.9-16.4c0-10.2-7.2-16.7-15.9-16.7
    			c-8.6,0-15.9,6.8-15.9,16.7C278.7,367.4,286.3,373.5,294.7,373.5z"
          />
          <path
            style={{ fill: color }}
            d="M362.7,361.5c0.3,6.5,5.5,12.2,15.2,12.2c8.7,0,14.8-4.1,14.9-10.8c0.1-4.6-1.9-8.6-12.2-11.5l-12.2-3.4
    			c-22.4-6.9-26.3-20.1-26.3-29.2c0-18.1,15.5-30.4,35-30.4c19.6,0,34.4,11.7,34.4,31.1h-21.5c0-6.8-4.6-11.5-13.1-11.5
    			c-7.5,0-13.1,4.1-13.1,10.2c0,2.7,1,7.5,10.9,10.3l12.1,3.8c24.6,7.1,28.2,20.9,27.9,30.7c-0.3,20.2-18.6,29.8-36.6,29.8
    			c-22.1,0-36.9-13.1-36.9-31.4H362.7z"
          />
          <path
            style={{ fill: color }}
            d="M438.1,285c6.9,0,12.5,5.2,12.5,11.9c0,6.8-5.6,12.1-12.5,12.1s-12.8-5.3-12.8-12.1
    			C425.3,290.2,431.2,285,438.1,285z M448.3,391.3h-20.4v-68.9h20.4V391.3z"
          />
          <path
            style={{ fill: color }}
            d="M495.8,407.3c15.6,0,19.9-10.8,19-24.5c-3.2,6.3-12.1,10-20.7,10c-17.7,0-34.4-14-34.4-35.7
    			c0-22.1,16.7-36.1,34.4-36.1c8.6,0,17.3,3.7,20.7,10v-8.6h19.9v59.3c0,29.6-14.5,44-38.9,44c-15.2,0-28.2-8.6-33.9-21.4
    			c5.2-2.5,11.4-5.6,16.5-8.1C480.8,402.6,488.9,407.3,495.8,407.3z M497.7,340.5c-8.7,0-16.5,6.5-16.5,16.2
    			c0,10.3,7.8,16.8,16.5,16.8c8.4,0,16.7-6.8,16.7-16.8C514.4,346.4,506.3,340.5,497.7,340.5z"
          />
          <path
            style={{ fill: color }}
            d="M571.4,391.3h-20.5V285h20.5v48.2c2.8-8.6,12.8-12.2,19.3-12.2c18.1,0,27.6,12.1,27.6,32.9v37.5
    			c-3.4,0-17.1,0-20.5,0v-36.7c0-9-6.5-13.7-12.7-13.7c-6.5,0-13.7,3.5-13.7,14V391.3z"
          />
          <path
            style={{ fill: color }}
            d="M673.7,322.5v16.2h-14.5v52.7h-20.4v-52.7h-12.5v-16.2h12.5v-26.4h20.4v26.4H673.7z"
          />
        </g>
        <g>
          <path
            style={{ fill: primary }}
            d="M315.6,213.2c58.9,0,106.6-47.7,106.6-106.6S374.5,0,315.6,0h-39.5v34.4h39.5c39.9,0,72.2,32.3,72.2,72.2
    			s-32.3,72.2-72.2,72.2h-39.5v34.4H315.6z"
          />
          <path
            style={{ fill: primary }}
            d="M339.8,99.8c-8.7,0-15.7-7-15.7-15.7c0-5.8,3.1-10.8,7.7-13.6c-5-2.2-10.4-3.5-16.2-3.5
    			c-21.8,0-39.5,17.7-39.5,39.5s17.7,39.5,39.5,39.5c21.8,0,39.5-17.7,39.5-39.5c0-4.7-0.8-9.3-2.4-13.5
    			C349.9,97.2,345.2,99.8,339.8,99.8z"
          />
        </g>
      </g>
    </svg>
  );
};

export default Logo;
